import * as React from "react";
import { compose, NavigationItem, withFeatureFlags, } from "@atlassiansox/microscopekit";
import UploadIcon from "@atlaskit/icon/glyph/upload";
// These links show up in the navigation sidebar for urls starting with `/services/{service_name}`
var MicrosNavigationLinks = function (props) {
    var id = props.id, flags = props.flags;
    if (!flags["microsPlugin"]) {
        return null;
    }
    return (React.createElement(NavigationItem, { icon: React.createElement(UploadIcon, { label: "Deployments" }), text: "Deployments", href: "/services/" + encodeURIComponent(id) + "/deployments" }));
};
export var MicrosNavigation = compose(withFeatureFlags)(MicrosNavigationLinks);
